// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

import { MsalProvider } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';

import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import Login from 'pages/authentication/Login';
import AccessTokenInterceptor from 'pages/authentication/AccessTokenInterceptor';
import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './themes/toastifyCustomColors.css';
import { LicenseInfo } from '@mui/x-license-pro';
import { useSelector } from 'react-redux';
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY);

function App({ msalInstance }) {
    const currentTheme = useSelector((state) => state.menu.theme);
    const dispatch = useDispatch();
    useEffect(() => {
        const callbackId = msalInstance.addEventCallback((event) => {
            if (event.eventType === EventType.LOGIN_SUCCESS) {
                msalInstance.setActiveAccount(event.payload.account);
                dispatch(setAccount(event.payload.account[0]));
            }
        });

        return () => {
            msalInstance.removeEventCallback(callbackId);
        };
    }, []);

    return (
        <MsalProvider instance={msalInstance}>
            <ThemeCustomization>
                <AuthenticatedTemplate>
                    <AccessTokenInterceptor>
                        <ScrollTop>
                            <Routes />
                            <ToastContainer theme={currentTheme} />
                        </ScrollTop>
                    </AccessTokenInterceptor>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <Login />
                </UnauthenticatedTemplate>
            </ThemeCustomization>
        </MsalProvider>
    );
}

export default App;
